import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useInitData = () => {
  const router = useRouter();

  const { setReferralId, setPromoCode } = useEnterStore();
  const [isReferralFlow, setIsReferralFlow] = useState(false);

  const fetchReferralDetails = async () => {
    const referralId = router.query?.ri;

    if (referralId) {
      setIsReferralFlow(true);
      setReferralId(referralId ? referralId.toString() : null);
      return;
    }
  };

  const fetchPromoCodeDetails = async () => {
    const promoCode = router.query?.pc;

    if (promoCode) {
      setPromoCode(promoCode ? promoCode.toString() : null);
      return;
    }
  };

  useEffect(() => {
    if (router.isReady) {
      fetchReferralDetails();
      fetchPromoCodeDetails();
    }
  }, [router.isReady, router.query?.ri]);

  return {
    isReferralFlow,
  };
};
